import { TabsProps } from 'antd';
import { TFunction } from 'react-i18next';

export const getProjectTabs = (t: TFunction): TabsProps['items'] => [
  { key: 'ACTIVE', label: t('ProjectTabs.active') },
  { key: 'NON_ACTIVE', label: t('ProjectTabs.nonActive') },
  { key: 'ARCHIVED', label: t('ProjectTabs.archived') },
  { key: 'ALL', label: t('ProjectTabs.all') },
];
